<div class="container-fluid">
    <div class="row" *ngFor="let item of items; index as i">
        <div class="col d-flex align-items-center mb-1">
            <app-svg-icon *ngIf="item.Checkpoint" [size]="16" icon="patch-check-fill" class="text-primary me-1">
            </app-svg-icon>
            <h3 class="mb-0 pe-1 mas-chico" [style.color]="colores[obtenerId(pregunta.Tipo)]"
                [attr.item-id]="(!accesoPublico ? item.Id : null)"
                ngbTooltip="{{(!accesoPublico ? item.Id : null)}}" container="body">
                {{ item.IdRelativo }}
            </h3>
            <input type="text" class="form-control white-borders" [(ngModel)]="item.Texto" [disabled]="accesoPublico" />
        </div>
        <div class="col-3">
            <ng-select [items]="preguntas" bindLabel="texto" bindValue="id" [clearable]="false"
                [(ngModel)]="item.PreguntaSiguiente" [disabled]="accesoPublico">
            </ng-select>
        </div>
        <div class="col flex-grow-0 text-end my-auto">
            <div ngbDropdown class="d-inline-block" container="body" *ngIf="!accesoPublico">
                <app-svg-icon ngbDropdownToggle class="dropdown-sin-flecha" [size]="24" icon="three-dots-vertical">
                </app-svg-icon>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem [command]="borrarCmd" [commandArg]="item">Borrar</button>
                    <button ngbDropdownItem (click)="abrirEditorCondiciones(item)">Editor de condiciones</button>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="!accesoPublico">
        <div class="col flex-grow-0 h3 mb-0 pe-0">+</div>
        <div class="col mb-3">
            <input type="text" placeholder="Agregue una respuesta..." class="form-control no-borders"
                [(ngModel)]="textoItem" (keyup.enter)="agregarCmd.ejecutar()" [disabled]="!agregarCmd.puedeEjecutarse" />
        </div>
    </div>
</div>
